import type { FC } from 'react';

import CurrencySelect from '@zen/Components/CurrencySelect';
import type { Currency } from '@zen/types';
import type { Nullable } from '@zen/utils/typescript';

import type { FormFieldProps } from '../FormField';
import FormField from '../FormField';
import type { FormInstance } from '../types';

interface Props extends FormFieldProps {
  availableCurrencies?: Currency[];
  isClearable?: boolean;
  isDisabled?: boolean;
  renderMenuInPortal?: boolean;
}

const FormCurrencySelect: FC<Props> = (props) => {
  return (
    <FormField {...props}>
      {(field: { error: boolean; name: string; value: Nullable<Currency> }, form: FormInstance<unknown>) => (
        <CurrencySelect
          {...field}
          hasError={field.error}
          isClearable={props.isClearable}
          isDisabled={props.isDisabled}
          onChange={(value: Nullable<Currency>) => form.setFieldValue(field.name, value)}
          renderMenuInPortal={props.renderMenuInPortal}
        />
      )}
    </FormField>
  );
};

export default FormCurrencySelect;
